import { render } from "./TicketDesign.vue?vue&type=template&id=22947341&scoped=true"
import script from "./TicketDesign.vue?vue&type=script&lang=js"
export * from "./TicketDesign.vue?vue&type=script&lang=js"

import "./TicketDesign.vue?vue&type=style&index=0&id=22947341&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22947341"]])

export default __exports__